module.exports = __webpack_public_path__ + "media/images/badge/campionato-vincente_secondary-27e9bad0ea676eef7e9da8ec4a22a38a.png";